export const selectStores = (state) => state.stores;
